import type { EventName } from "@lit/react";
import { RadioGroup as RadioGroupElement, type RadioGroupEventMap as _RadioGroupEventMap, } from "@vaadin/radio-group/vaadin-radio-group.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { RadioGroupElement, };
export type RadioGroupEventMap = Readonly<{
    onInvalidChanged: EventName<_RadioGroupEventMap["invalid-changed"]>;
    onValidated: EventName<_RadioGroupEventMap["validated"]>;
    onValueChanged: EventName<_RadioGroupEventMap["value-changed"]>;
}>;
const events = { onInvalidChanged: "invalid-changed", onValidated: "validated", onValueChanged: "value-changed" } as RadioGroupEventMap;
export type RadioGroupProps = WebComponentProps<RadioGroupElement, RadioGroupEventMap>;
export const RadioGroup = createComponent({
    elementClass: RadioGroupElement, events, react: React, tagName: "vaadin-radio-group"
});
